var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnYourDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.974976 0.44873L33.4875 19.249L66 0.44873L56.3206 19.2346L44.8917 25.8434L33.4875 32.4378L22.0833 25.8434L10.6543 19.2346L0.974976 0.44873ZM25.1126 37.2805L33.4875 42.1232L41.8624 37.2805L49.2131 33.0291L45.8376 39.5782L41.9943 47.0402L33.4875 63.5509L24.9807 47.0402L21.1354 39.5782L17.7619 33.0291L25.1126 37.2805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnYourDataIcon);
export default __webpack_public_path__ + "static/media/own-your-data-icon.b39328fbad270f747bf15a6a07834f72.svg";
export { ForwardRef as ReactComponent };